import { Box, IconButton, Typography, ToggleButton, ToggleButtonGroup } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import moment from "moment";
import { Navigate } from "react-big-calendar";

const CalendarToolbar = ({ date, view, onNavigate, onView }) => {
    const getTitle = () => {
        if (view === "month") {
            return moment(date).format("MMMM YYYY");
        }

        if (view === "week") {
            const start = moment(date).startOf("week");
            const end = moment(date).endOf("week");
            return `${start.format("MMM D")} – ${end.format("MMM D, YYYY")}`;
        }

        return moment(date).format("MMMM D, YYYY");
    };

    return (
        <Box
            sx={{
                mb:1,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
               
            }}
        >
            {/* Gauche */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 500 }}>
                    {getTitle()}
                </Typography>
                <IconButton size="small" onClick={() => onNavigate(Navigate.PREVIOUS)}>
                    <ChevronLeftIcon fontSize="medium" />
                </IconButton>

                <IconButton size="small" onClick={() => onNavigate(Navigate.NEXT)}>
                    <ChevronRightIcon fontSize="medium" />
                </IconButton>


            </Box>

            {/* Droite */}
            <ToggleButtonGroup
                size="small"
                value={view}
                exclusive
                onChange={(e, v) => v && onView(v)}
            >
                <ToggleButton value="day">Day</ToggleButton>
                <ToggleButton value="week">Week</ToggleButton>
                <ToggleButton value="month">Month</ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};

export default CalendarToolbar;
